const fields = [
  {
    field: "companyName",
    required: true,
    label: "Bedrijfsnaam",
    value: "",
    col: 6,
    display: "textfield",
  },

  {
    field: "fao",
    required: true,
    label: "T.a.v.",
    value: "",
    col: 6,
    display: "textfield",
  },
  {
    field: "street",
    required: true,
    label: "Straat",
    value: "",
    col: 4,
    display: "textfield",
  },
  {
    field: "postalCode",
    required: true,
    label: "Postcode",
    value: "",
    col: 4,
    display: "textfield",
  },
  {
    field: "city",
    required: true,
    label: "Plaatsnaam",
    value: "",
    col: 4,
    display: "textfield",
  },
  {
    field: "email",
    required: true,
    label: "Emailadres",
    value: "",
    col: 6,
    display: "textfield",
  },
  {
    field: "secondaryEmail",
    required: false,
    label: "Secundair Emailadres",
    value: "",
    col: 6,
    display: "textfield",
    visible: false,
  },
];

export default fields;
